// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable selector-class-pattern */
.radio {
  display: flex;
}
.radio.row {
  flex-direction: row;
}
.radio.row > *:not(:last-child) {
  margin-right: 2.4rem;
}
.radio.column {
  flex-direction: column;
}
.radio.column > *:not(:last-child) {
  margin-bottom: 2.4rem;
}
.radio.disabled {
  pointer-events: none;
}
.radio.disabled .radio__input {
  opacity: 0.5;
}
.radio__input {
  outline: none;
}
.radio__label {
  margin-left: 1.2rem;
}
.radio__item.radio__item-title {
  display: flex;
  align-items: center;
}
.radio__item .radio__item-description {
  padding-top: 1.2rem;
}

/* stylelint-enable selector-class-pattern */`, "",{"version":3,"sources":["webpack://./src/kit/components/Fields/Radio/index.scss"],"names":[],"mappings":"AAAA,6CAAA;AACA;EACE,aAAA;AACF;AACE;EACE,mBAAA;AACJ;AACI;EACE,oBAAA;AACN;AAGE;EACE,sBAAA;AADJ;AAGI;EACE,qBAAA;AADN;AAKE;EACE,oBAAA;AAHJ;AAKI;EACE,YAAA;AAHN;AAOE;EACE,aAAA;AALJ;AAQE;EACE,mBAAA;AANJ;AAUI;EACE,aAAA;EACA,mBAAA;AARN;AAWI;EACE,mBAAA;AATN;;AAaA,4CAAA","sourcesContent":["/* stylelint-disable selector-class-pattern */\n.radio {\n  display: flex;\n\n  &.row {\n    flex-direction: row;\n\n    & > *:not(:last-child) {\n      margin-right: 2.4rem;\n    }\n  }\n\n  &.column {\n    flex-direction: column;\n\n    & > *:not(:last-child) {\n      margin-bottom: 2.4rem;\n    }\n  }\n\n  &.disabled {\n    pointer-events: none;\n\n    .radio__input {\n      opacity: 0.5;\n    }\n  }\n\n  &__input {\n    outline: none;\n  }\n\n  &__label {\n    margin-left: 1.2rem;\n  }\n\n  &__item {\n    &.radio__item-title {\n      display: flex;\n      align-items: center;\n    }\n\n    .radio__item-description {\n      padding-top: 1.2rem;\n    }\n  }\n}\n/* stylelint-enable selector-class-pattern */\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
